<template>
  <div class="simulationGroupPointList">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SimulationContentDeliverySidebarPointList',
}
</script>

<style scoped>
.simulationGroupPointList {
  background: white;
}
</style>
